import React, { Component } from 'react';
import QA from './QA';

export class QAList extends Component {
  componentDidMount() {
    console.log(this.props.qas);
  }

  render() {
    return this.props.softQaList.map(qaData => (
      <QA
        key={qaData.qaId}
        qaData={qaData}
        submitReply={this.props.submitReply}
        prodId={this.props.prodId}
        userEmail={this.props.userEmail}
        devAccount={this.props.devAccount}
        loggedIn={this.props.loggedIn}
      />
    ));
  }
}

export default QAList;
